import { DEFAULT_THEME, themes } from './index'

export const mapTheme = (variables) => {
  return {
    '--color-primary': variables?.primary?.default || '',
    '--color-primary-darker': variables?.primary?.darker || variables?.primary?.default || '',
    '--color-primary-lighter': variables?.primary?.lighter || variables?.primary?.default || '',

    '--color-secondary': variables?.secondary.default || '',
    '--color-secondary-darker': variables?.secondary.darker || variables?.secondary.default || '',
    '--color-secondary-lighter': variables?.secondary.lighter || variables?.secondary.default || '',

    '--color-tertiary': variables?.tertiary?.default || '',
    '--color-tertiary-darker': variables?.tertiary?.darker || variables?.tertiary?.default || '',
    '--color-tertiary-lighter': variables?.tertiary?.lighter || variables?.tertiary?.default || '',

    '--color-positive': variables?.positive?.default || '',
    '--color-positive-darker': variables?.positive?.darker || variables?.positive?.default || '',
    '--color-positive-lighter': variables?.positive?.lighter || variables?.positive?.default || '',

    '--color-negative': variables?.negative?.default || '',
    '--color-negative-darker': variables?.negative?.darker || variables?.negative?.default || '',
    '--color-negative-lighter': variables?.negative?.lighter || variables?.negative?.default || '',

    '--color-grayscale': variables?.grayscale?.default || '',
    '--color-grayscale-darker': variables?.grayscale?.darker || variables?.grayscale?.default || '',
    '--color-grayscale-lighter': variables?.grayscale?.lighter || variables?.grayscale?.default || '',
    
    '--color-warning': variables?.warning?.default || '',
    '--color-warning-darker': variables?.warning?.darker || variables?.warning?.default || '',
    '--color-warning-lighter': variables?.warning?.lighter || variables?.warning?.default || '',
  }
}

export const setTheme = (variables) => {
  const themeObject = mapTheme(variables)
  if (!themeObject) return

  const root = document.documentElement

  Object.keys(themeObject).forEach((property) => {
    if (property === 'name') {
      return
    }

    root.style.setProperty(property, themeObject[property])
  })
}

export const applyTheme = (theme) => {
  const themeObject = mapTheme(themes[theme])
  if (!themeObject) return

  const root = document.documentElement

  Object.keys(themeObject).forEach((property) => {
    if (property === 'name') {
      return
    }

    root.style.setProperty(property, themeObject[property])
  })
}

export const getTheme = (theme = DEFAULT_THEME) => {
  const themeObject = mapTheme(themes[theme])

  if (!themeObject) {
    return {}
  }

  return themeObject
}

export const getThemeAsString = (theme = DEFAULT_THEME) => {
  return Object.entries(getTheme(theme)).reduce((string, [key, val]) => {
    if (val !== '') {
      string = `${string} ${key}:${val};`
    }

    return string
  }, '')
}

export const extend = (extending, newTheme) => {
  return { ...extending, ...newTheme }
}
